<template>
  <div>
    <div v-if="selectedPillar && showFixedSlider" class="fixed-slider">
      <label>Percentage Increase</label>
      <vue-slider
        v-model="percentageIncrease"
        :marks="[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
      />
    </div>

    <div class="row">
      <div class="col">
        <div class="col-12 text-center animate__animated animate__fadeIn">
          <p class="font-weight-500 help-text-green text-center">
            Choose a City from the dropdown to begin <br />then move the cursor
            to the level you want to consider, and see the table change
          </p>
        </div>

        <div
          class="row what-if-buttons mb-5 text-center"
          style="max-width: 600px"
        >
          <div class="col-12 mb-3">
            <b-form-select
              size="md"
              v-model="selectedCity"
              :options="cities"
            ></b-form-select>
          </div>
          <div v-if="selectedCity !== null" class="col-12">
            <b-form-select
              size="md"
              v-model="selectedPillar"
              :options="pillars"
            ></b-form-select>
          </div>
          <div v-if="selectedCity !== null" class="col-12 pt-3 mb-5">
            <label>Percentage Increase</label>
            <vue-slider
              v-model="percentageIncrease"
              :marks="[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
            />
          </div>
        </div>

        <div class="col text-center">
          <div class="d-inline-flex">
            <h1
              class="font-weight-300 mt-4 animate__animated animate__fadeInUp"
              style="font-size: 30px"
            >
              <span>What if </span>
              <span v-if="getCityName !== 'none'"
                ><span
                  class="font-weight-700 text-underline link-to-city"
                  @click="selectCity(getCityName)"
                  >{{ getCityName }}</span
                ></span
              >
              <span v-if="getCityName !== 'none' && selectedPillar === 'FREI'">
                improved <span class="font-weight-700">all pillars</span></span
              >
              <span
                v-if="
                  getCityName !== 'none' &&
                  selectedPillar === 'PeopleCentricity'
                "
              >
                improved
                <span class="font-weight-700">People Centricity</span></span
              >
              <span
                v-if="
                  getCityName !== 'none' &&
                  selectedPillar &&
                  selectedPillar !== 'FREI' &&
                  selectedPillar !== 'PeopleCentricity'
                "
              >
                improved
                <span class="font-weight-700">{{
                  getPillarDisplayName(selectedPillar)
                }}</span></span
              >
              <span
                v-if="
                  getCityName !== 'none' && selectedPillar && percentageIncrease
                "
              >
                by
                <span class="font-weight-700"
                  >{{ percentageIncrease }}%</span
                ></span
              >
            </h1>
          </div>

          <div
            v-if="
              getCityName !== 'none' && selectedPillar && percentageIncrease > 0
            "
            class="mt-1"
          >
            <h4
              class="font-weight-400 text-muted animate__animated animate__fadeInUp"
              style="animation-delay: 0.2s"
            >
              Its ranking would change from
              <span class="font-weight-700 text-primary">{{
                getCurrentRank
              }}</span>
              to
              <span class="font-weight-700 text-success">{{ getNewRank }}</span>
            </h4>
          </div>
        </div>
        <div class="mt-4" />
        <div class="text-center my-1" style="text-align: center; width: 100%">
          <p
            class="font-weight-500 help-text-green text-center"
            style="text-align: center"
          >
            Please scroll to the right to see additional pillars
          </p>
        </div>

        <div class="col-12 mt-5" style="overflow: scroll" id="sliderContainer">
          <b-table
            ref="rankingsTable"
            :items="cityWhatIfDataSetForGivenScenario"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-compare="myCompare"
            table-class="rankingsTable"
            thead-class="rankingsTableHead"
            tbody-class="rankingsTableBody"
            responsive
          >
            <template #cell(City)="data">
              <div
                class="city-cell"
                :class="{ selectedCountry: selectedCity === data.item.Slug }"
                @click="selectCity(data.item.Slug)"
              >
                <span class="city-name">
                  {{ data.item.City }}
                </span>
                <small class="country-name">{{ data.item.Country }}</small>
              </div>
            </template>

            <template #cell(FREI)="data">
              <div class="py-3" :class="getBackgroundClass(data.item.FREI)">
                <div class="rank">{{ data.item.FREI.rank }}</div>
                <div>{{ data.item.FREI.value }}</div>
              </div>
            </template>

            <template #cell(PeopleCentricity)="data">
              <div
                class="py-3"
                :class="getBackgroundClass(data.item.PeopleCentricity)"
              >
                <div class="rank">{{ data.item.PeopleCentricity.rank }}</div>
                <div>{{ data.item.PeopleCentricity.value }}</div>
              </div>
            </template>

            <template #cell(Openness)="data">
              <div class="py-3" :class="getBackgroundClass(data.item.Openness)">
                <div class="rank">{{ data.item.Openness.rank }}</div>
                <div>{{ data.item.Openness.value }}</div>
              </div>
            </template>

            <template #cell(Sustainability)="data">
              <div
                class="py-3"
                :class="getBackgroundClass(data.item.Sustainability)"
              >
                <div class="rank">{{ data.item.Sustainability.rank }}</div>
                <div>{{ data.item.Sustainability.value }}</div>
              </div>
            </template>

            <template #cell(InstitutionsGovernance)="data">
              <div
                class="py-3"
                :class="getBackgroundClass(data.item.InstitutionsGovernance)"
              >
                <div class="rank">
                  {{ data.item.InstitutionsGovernance.rank }}
                </div>
                <div>{{ data.item.InstitutionsGovernance.value }}</div>
              </div>
            </template>

            <template #cell(TransportInfrastructure)="data">
              <div
                class="py-3"
                :class="getBackgroundClass(data.item.TransportInfrastructure)"
              >
                <div class="rank">
                  {{ data.item.TransportInfrastructure.rank }}
                </div>
                <div>{{ data.item.TransportInfrastructure.value }}</div>
              </div>
            </template>

            <template #cell(Innovation)="data">
              <div
                class="py-3"
                :class="getBackgroundClass(data.item.Innovation)"
              >
                <div class="rank">{{ data.item.Innovation.rank }}</div>
                <div>{{ data.item.Innovation.value }}</div>
              </div>
            </template>

            <template #cell(Vibrancy)="data">
              <div class="py-3" :class="getBackgroundClass(data.item.Vibrancy)">
                <div class="rank">{{ data.item.Vibrancy.rank }}</div>
                <div>{{ data.item.Vibrancy.value }}</div>
              </div>
            </template>

            <template #cell(EIntelligence)="data">
              <div
                class="py-3"
                :class="getBackgroundClass(data.item.EIntelligence)"
              >
                <div class="rank">{{ data.item.EIntelligence.rank }}</div>
                <div>{{ data.item.EIntelligence.value }}</div>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BFormSelect, BTable } from "bootstrap-vue";
import _ from "lodash";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import citiesData from "../../data_2025/cities.json";
import cityWhatIfDataMaximums from "../../data_2025/what-ifs/cityWhatIfDataMaximums.json";
import cityWhatIfData from "../../data_2025/what-ifs/cityWhatIfs.js";

export default {
  name: "WhatIfsTable",
  components: {
    BTable,
    BFormSelect,
    VueSlider,
  },
  data() {
    return {
      showFixedSlider: false,
      sliderStartPosition: null,
      sliderPosition: null,
      scrollPosition: null,
      sortDesc: true,
      percentageIncrease: 0,
      selectedCity: null,
      selectedPillar: "FREI",
      sortBy: "FREI",
      cities: [
        { value: null, text: "Select a city", disabled: true },
        ...Object.keys(citiesData)
          .map((slug) => ({
            value: slug,
            text: `${citiesData[slug].city}, ${citiesData[slug].country}`,
          }))
          .sort((a, b) => a.text.localeCompare(b.text)),
      ],
      pillars: [
        { value: "FREI", text: "Cities Future Readiness Index" },
        { value: "PeopleCentricity", text: "People Centricity" },
        { value: "Openness", text: "Openness" },
        { value: "Sustainability", text: "Sustainability" },
        { value: "InstitutionsGovernance", text: "Institutions & Governance" },
        {
          value: "TransportInfrastructure",
          text: "Transport & Infrastructure",
        },
        { value: "Innovation", text: "Innovation" },
        { value: "Vibrancy", text: "Vibrancy" },
        { value: "EIntelligence", text: "E-Readiness" },
      ],
      options: [
        { text: "Current Scores", value: "current" },
        { text: "1% Improvement", value: "1_percent" },
        { text: "2% Improvement", value: "2_percent" },
        { text: "3% Improvement", value: "3_percent" },
      ],
      transProps: {
        name: "flip-list",
      },
      scenario: "current",
      cityWhatIfDataMaximums: cityWhatIfDataMaximums,
      cityWhatIfData: cityWhatIfData,
      fields: [
        {
          key: "City",
          sortable: false,
          tdClass: "city-name-column",
          thClass: "comparisonHeader",
          sortDirection: "desc",
        },
        {
          key: "FREI",
          label: "CFRI",
          sortable: true,
          tdClass: "text-center comparisonCellNoPadding",
          thClass: "comparisonHeader",
          sortDirection: "desc",
        },
        {
          key: "PeopleCentricity",
          label: "People Centricity",
          sortable: true,
          tdClass: "text-center comparisonCellNoPadding",
          thClass: "comparisonHeader",
          sortDirection: "desc",
        },
        {
          key: "Openness",
          label: "Openness",
          sortable: true,
          tdClass: "text-center comparisonCellNoPadding",
          thClass: "comparisonHeader",
          sortDirection: "desc",
        },
        {
          key: "Sustainability",
          label: "Sustainability",
          sortable: true,
          tdClass: "text-center comparisonCellNoPadding",
          thClass: "comparisonHeader",
          sortDirection: "desc",
        },
        {
          key: "InstitutionsGovernance",
          label: "Institutions & Governance",
          sortable: true,
          tdClass: "text-center comparisonCellNoPadding",
          thClass: "comparisonHeader",
          sortDirection: "desc",
        },
        {
          key: "TransportInfrastructure",
          label: "Transport & Infrastructure",
          sortable: true,
          tdClass: "text-center comparisonCellNoPadding",
          thClass: "comparisonHeader",
          sortDirection: "desc",
        },
        {
          key: "Innovation",
          label: "Innovation",
          sortable: true,
          tdClass: "text-center comparisonCellNoPadding",
          thClass: "comparisonHeader",
          sortDirection: "desc",
        },
        {
          key: "Vibrancy",
          label: "Vibrancy",
          sortable: true,
          tdClass: "text-center comparisonCellNoPadding",
          thClass: "comparisonHeader",
          sortDirection: "desc",
        },
        {
          key: "EIntelligence",
          label: "E-Readiness",
          sortable: true,
          tdClass: "text-center comparisonCellNoPadding",
          thClass: "comparisonHeader",
          sortDirection: "desc",
        },
      ],
      cityWhatIfDataSetForGivenScenarioStartValues: cityWhatIfData,
      startValues: _.cloneDeep(cityWhatIfData),
    };
  },
  watch: {
    percentageIncrease() {
      if (this.selectedPillar === "FREI") {
        const percentage = 0.01 * this.percentageIncrease;
        const cityIndex = this.cityWhatIfDataSetForGivenScenarioStartValues[
          this.scenario
        ].findIndex((city) => city.Slug === this.selectedCity);

        if (cityIndex !== -1) {
          const startValue =
            this.startValues[this.scenario][cityIndex][this.selectedPillar]
              .value;
          const newValue = startValue * (1 + percentage);
          this.cityWhatIfDataSetForGivenScenarioStartValues[this.scenario][
            cityIndex
          ][this.selectedPillar].value = Math.round(newValue * 100) / 100;

          // Get Starting Pillar Values
          const pillars = [
            "PeopleCentricity",
            "Openness",
            "Sustainability",
            "InstitutionsGovernance",
            "TransportInfrastructure",
            "Innovation",
            "Vibrancy",
            "EIntelligence",
          ];
          const newPillarValues = [];

          pillars.forEach((pillar) => {
            const startPillarValue =
              this.startValues[this.scenario][cityIndex][pillar].value;
            const newPillarValue = startPillarValue * (1 + percentage);
            this.cityWhatIfDataSetForGivenScenarioStartValues[this.scenario][
              cityIndex
            ][pillar].value = (Math.round(newPillarValue * 100) / 100).toFixed(
              2
            );
            newPillarValues.push(newPillarValue);
          });

          // Calculate New Future Readiness Value (average of all pillars)
          const newFREI =
            newPillarValues.reduce((sum, value) => sum + value, 0) /
            newPillarValues.length;
          this.cityWhatIfDataSetForGivenScenarioStartValues[this.scenario][
            cityIndex
          ].FREI.value = (Math.round(newFREI * 100) / 100).toFixed(2);

          // Recalculate ranks for all cities
          this.recalculateRanks();
        }
      } else {
        // Handle individual pillar changes
        const percentage = 0.01 * this.percentageIncrease;
        const cityIndex = this.cityWhatIfDataSetForGivenScenarioStartValues[
          this.scenario
        ].findIndex((city) => city.Slug === this.selectedCity);

        if (cityIndex !== -1) {
          const startValue =
            this.startValues[this.scenario][cityIndex][this.selectedPillar]
              .value;
          const newValue = startValue * (1 + percentage);
          this.cityWhatIfDataSetForGivenScenarioStartValues[this.scenario][
            cityIndex
          ][this.selectedPillar].value = (
            Math.round(newValue * 100) / 100
          ).toFixed(2);

          const pillars = [
            "PeopleCentricity",
            "Openness",
            "Sustainability",
            "InstitutionsGovernance",
            "TransportInfrastructure",
            "Innovation",
            "Vibrancy",
            "EIntelligence",
          ];
          const pillarValues = pillars.map((pillar) =>
            Number(
              this.cityWhatIfDataSetForGivenScenarioStartValues[this.scenario][
                cityIndex
              ][pillar].value
            )
          );
          const newFREI =
            pillarValues.reduce((sum, value) => sum + value, 0) /
            pillarValues.length;
          this.cityWhatIfDataSetForGivenScenarioStartValues[this.scenario][
            cityIndex
          ].FREI.value = (Math.round(newFREI * 100) / 100).toFixed(2);

          // Recalculate ranks
          this.recalculateRanks();
        }
      }
    },
    selectedPillar() {
      this.sortDesc = true;
      this.sortBy = "FREI";
      this.percentageIncrease = 0;
    },
    selectedCity() {
      this.percentageIncrease = 0;
    },
  },
  computed: {
    getCityName() {
      let selectedCityName = "none";
      if (this.selectedCity !== null) {
        const cityData = citiesData[this.selectedCity];
        if (cityData) {
          selectedCityName = cityData.city;
        }
      }
      return selectedCityName;
    },
    getPillarName() {
      const pillar = this.pillars.find((p) => p.value === this.selectedPillar);
      return pillar ? pillar.text : "Unknown Pillar";
    },
    cityWhatIfDataSetForGivenScenario() {
      return this.cityWhatIfData[this.scenario];
    },
    cityWhatIfDataMaximumsForGivenScenario() {
      return this.cityWhatIfDataMaximums[this.scenario];
    },
    getCurrentRank() {
      if (!this.selectedCity || !this.selectedPillar) return null;
      const originalData = this.startValues[this.scenario];
      const cityData = originalData.find(
        (city) => city.Slug === this.selectedCity
      );
      return cityData ? cityData[this.selectedPillar].rank : null;
    },
    getNewRank() {
      if (
        !this.selectedCity ||
        !this.selectedPillar ||
        this.percentageIncrease === 0
      )
        return null;
      const currentData =
        this.cityWhatIfDataSetForGivenScenarioStartValues[this.scenario];
      const cityData = currentData.find(
        (city) => city.Slug === this.selectedCity
      );
      return cityData ? cityData[this.selectedPillar].rank : null;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);
  },
  destroy() {
    window.removeEventListener("scroll", this.updateScroll);
  },
  methods: {
    getCenteredDivPosition() {
      this.sliderStartPosition = this.sliderPosition;
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
      this.setSliderState();
    },
    setSliderState() {
      if (this.scrollPosition > 750) {
        this.showFixedSlider = true;
      } else {
        this.showFixedSlider = false;
      }
    },
    myCompare(aRow, bRow, key) {
      const aValue = aRow[key].value;
      const bValue = bRow[key].value;
      if (aValue > bValue) {
        return 1;
      }
      if (aValue < bValue) {
        return -1;
      }
      return 0;
    },
    getPillarDisplayName(pillar) {
      const pillarMap = {
        PeopleCentricity: "People Centricity",
        Openness: "Openness",
        Sustainability: "Sustainability",
        InstitutionsGovernance: "Institutions & Governance",
        TransportInfrastructure: "Transport & Infrastructure",
        Innovation: "Innovation",
        Vibrancy: "Vibrancy",
        EIntelligence: "E-Readiness",
      };
      return pillarMap[pillar] || pillar;
    },
    getBackgroundClass(value) {
      if (!value || !value.rank) return "";

      const maxRank = 102;
      const opacityValue = (maxRank - value.rank) / maxRank;
      const opacityLevel = Math.max(
        1,
        Math.min(10, Math.round(opacityValue * 10))
      );
      return `comparisonCellNoPadding-${opacityLevel}`;
    },
    backgroundOpacity(value, key) {
      const maxValue = this.cityWhatIfDataMaximumsForGivenScenario[key];
      const opacityValue = value.value / maxValue;

      if (Math.round(opacityValue * 10) >= 10) {
        return "comparisonCell " + key + "Opacity10";
      } else if (Math.round(opacityValue * 10) >= 9) {
        return "comparisonCell " + key + "Opacity9";
      } else if (Math.round(opacityValue * 10) >= 8) {
        return "comparisonCell " + key + "Opacity8";
      } else if (Math.round(opacityValue * 10) >= 7) {
        return "comparisonCell " + key + "Opacity7";
      } else if (Math.round(opacityValue * 10) >= 6) {
        return "comparisonCell " + key + "Opacity6";
      } else if (Math.round(opacityValue * 10) >= 5) {
        return "comparisonCell " + key + "Opacity5";
      } else if (Math.round(opacityValue * 10) >= 4) {
        return "comparisonCell " + key + "Opacity4";
      } else if (Math.round(opacityValue * 10) >= 3) {
        return "comparisonCell " + key + "Opacity3";
      } else if (Math.round(opacityValue * 10) >= 2) {
        return "comparisonCell " + key + "Opacity2";
      } else {
        return "comparisonCell " + key + "Opacity1";
      }
    },
    getFREI(cityPillars) {
      const pillars = [
        "PeopleCentricity",
        "Openness",
        "Sustainability",
        "InstitutionsGovernance",
        "TransportInfrastructure",
        "Innovation",
        "Vibrancy",
        "EIntelligence",
      ];
      const cityTotal = pillars.reduce(
        (sum, pillar) => sum + Number(cityPillars[pillar].value),
        0
      );
      return (cityTotal / pillars.length).toFixed(2);
    },
    recalculateRanks() {
      const data =
        this.cityWhatIfDataSetForGivenScenarioStartValues[this.scenario];
      const pillars = [
        "FREI",
        "PeopleCentricity",
        "Openness",
        "Sustainability",
        "InstitutionsGovernance",
        "TransportInfrastructure",
        "Innovation",
        "Vibrancy",
        "EIntelligence",
      ];

      pillars.forEach((pillar) => {
        // Sort cities by pillar value (descending)
        const sortedCities = [...data].sort(
          (a, b) => Number(b[pillar].value) - Number(a[pillar].value)
        );

        // Assign new ranks
        sortedCities.forEach((city, index) => {
          const originalIndex = data.findIndex((c) => c.Slug === city.Slug);
          data[originalIndex][pillar].rank = index + 1;
        });
      });
    },
    selectCity(citySlug) {
      this.$emit("clickedCity", citySlug);
    },
  },
};
</script>

<style>
.what-if-buttons {
  margin: auto !important;
}

.what-if-buttons .form-group {
  width: 100%;
}

.what-if-buttons .form-control {
  font-size: 0.8rem;
}

.rankingsTable th:focus {
  outline: 0;
}

.rank {
  background: none !important;
  font-weight: bold;
  margin-top: 5px;
}

.rankingsTable th {
  border-top: solid 5px #fff !important;
  text-align: center;
}

.rankingsTable th:nth-child(2)[aria-sort="descending"],
.rankingsTable th:nth-child(2)[aria-sort="ascending"] {
  border-top: solid 5px #3ac7ffff !important;
  background: #fbfbfb;
}

.rankingsTable th:nth-child(3)[aria-sort="descending"],
.rankingsTable th:nth-child(3)[aria-sort="ascending"] {
  border-top: solid 5px #4e81c4 !important;
  background: #fbfbfb;
}

.rankingsTable th:nth-child(4)[aria-sort="descending"],
.rankingsTable th:nth-child(4)[aria-sort="ascending"] {
  border-top: solid 5px #66ad5d !important;
  background: #fbfbfb;
}

.rankingsTable th:nth-child(5)[aria-sort="descending"],
.rankingsTable th:nth-child(5)[aria-sort="ascending"] {
  border-top: solid 5px #e2aa23 !important;
  background: #fbfbfb;
}

.rankingsTable th:nth-child(6)[aria-sort="descending"],
.rankingsTable th:nth-child(6)[aria-sort="ascending"] {
  border-top: solid 5px #73339b !important;
  background: #fbfbfb;
}

.rankingsTable th:nth-child(7)[aria-sort="descending"],
.rankingsTable th:nth-child(7)[aria-sort="ascending"] {
  border-top: solid 5px #cc4c2a !important;
  background: #fbfbfb;
}

.rankingsTable th:nth-child(8)[aria-sort="descending"],
.rankingsTable th:nth-child(8)[aria-sort="ascending"] {
  border-top: solid 5px #f39c12 !important;
  background: #fbfbfb;
}

.rankingsTable th:nth-child(9)[aria-sort="descending"],
.rankingsTable th:nth-child(9)[aria-sort="ascending"] {
  border-top: solid 5px #27ae60 !important;
  background: #fbfbfb;
}

.rankingsTable th:nth-child(10)[aria-sort="descending"],
.rankingsTable th:nth-child(10)[aria-sort="ascending"] {
  border-top: solid 5px #8e44ad !important;
  background: #fbfbfb;
}

.countryName {
  padding: 1em !important;
}

.countryName:hover {
  color: white;
  cursor: initial;
}

.countryName span {
  font-weight: bold;
  padding: 12px;
  border-radius: 5px;
  margin-left: -10px;
  color: #4b4b4b;
}

.countryName span.selectedCountry {
  font-weight: bold;
  background: #4b4b4b;
  padding: 12px;
  border-radius: 5px;
  margin-left: -10px;
  color: white;
}

.city-cell {
  text-align: left;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.75rem 1rem;
  height: 100%;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-radius: 4px;
}

.city-cell.selectedCountry {
  background-color: #4b4b4b;
  color: white;
}

.city-name {
  font-weight: 600;
  font-size: 0.9rem;
  color: inherit;
  transition: all 0.2s ease;
}

.city-cell:hover .city-name {
  text-decoration: underline;
}

.city-cell.selectedCountry .city-name {
  color: white;
  text-decoration: underline;
}

.country-name {
  display: block;
  font-size: 0.75rem;
  color: #6c757d;
  margin-top: 1px;
}

.city-cell.selectedCountry .country-name {
  color: #e9ecef;
}

.in-text-select {
  border: none !important;
  box-shadow: none !important;
  font-size: 30px !important;
  color: black;
}

.link-to-city:hover {
  color: #0c7abf;
  cursor: pointer;
}

.fixed-slider {
  background: white;
  position: fixed;
  top: 0;
  width: 1024px;
  margin: auto;
  z-index: 100000;
  padding: 1em 2em 3em 2em;
  border-radius: 0px 0px 5px 5px;
  box-shadow: #00000033 -1px 5px 9px 0px;
}

.rankingsTable {
  font-size: 0.875rem;
}

.rankingsTable th {
  border-top: solid 5px #fff !important;
  text-align: center;
  font-weight: 600;
  vertical-align: middle;
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
}

.rankingsTable th:focus {
  outline: 0;
}

.city-name-column {
  background-color: #f8f9fa;
  min-width: 200px;
  position: sticky;
  left: 0;
  z-index: 5;
}

.rankingsTable td:nth-child(1) {
  padding: 0 !important;
}

/**
* 2nd column - Blue (Future Readiness)
*/
td:nth-child(2) .comparisonCellNoPadding-1 {
  background-color: rgba(66, 133, 244, 0.1);
}
td:nth-child(2) .comparisonCellNoPadding-2 {
  background-color: rgba(66, 133, 244, 0.2);
}
td:nth-child(2) .comparisonCellNoPadding-3 {
  background-color: rgba(66, 133, 244, 0.3);
}
td:nth-child(2) .comparisonCellNoPadding-4 {
  background-color: rgba(66, 133, 244, 0.4);
}
td:nth-child(2) .comparisonCellNoPadding-5 {
  background-color: rgba(66, 133, 244, 0.5);
}
td:nth-child(2) .comparisonCellNoPadding-6 {
  background-color: rgba(66, 133, 244, 0.6);
}
td:nth-child(2) .comparisonCellNoPadding-7 {
  background-color: rgba(66, 133, 244, 0.7);
}
td:nth-child(2) .comparisonCellNoPadding-8 {
  background-color: rgba(66, 133, 244, 0.8);
}
td:nth-child(2) .comparisonCellNoPadding-9 {
  background-color: rgba(66, 133, 244, 0.9);
}
td:nth-child(2) .comparisonCellNoPadding-10 {
  background-color: rgba(66, 133, 244, 1);
  color: white;
}

/**
* 3rd column - Dark Grey (People Centricity) 
*/
td:nth-child(3) .comparisonCellNoPadding-1 {
  background-color: rgba(233, 30, 99, 0.1);
}
td:nth-child(3) .comparisonCellNoPadding-2 {
  background-color: rgba(233, 30, 99, 0.2);
}
td:nth-child(3) .comparisonCellNoPadding-3 {
  background-color: rgba(233, 30, 99, 0.3);
}
td:nth-child(3) .comparisonCellNoPadding-4 {
  background-color: rgba(233, 30, 99, 0.4);
}
td:nth-child(3) .comparisonCellNoPadding-5 {
  background-color: rgba(233, 30, 99, 0.5);
}
td:nth-child(3) .comparisonCellNoPadding-6 {
  background-color: rgba(233, 30, 99, 0.6);
}
td:nth-child(3) .comparisonCellNoPadding-7 {
  background-color: rgba(233, 30, 99, 0.7);
}
td:nth-child(3) .comparisonCellNoPadding-8 {
  background-color: rgba(233, 30, 99, 0.8);
}
td:nth-child(3) .comparisonCellNoPadding-9 {
  background-color: rgba(233, 30, 99, 0.9);
}
td:nth-child(3) .comparisonCellNoPadding-10 {
  background-color: rgba(233, 30, 99, 1);
  color: white;
}

/**
* 4th column - Yellow (Openness)
*/
td:nth-child(4) .comparisonCellNoPadding-1 {
  background-color: rgba(244, 180, 0, 0.1);
}
td:nth-child(4) .comparisonCellNoPadding-2 {
  background-color: rgba(244, 180, 0, 0.2);
}
td:nth-child(4) .comparisonCellNoPadding-3 {
  background-color: rgba(244, 180, 0, 0.3);
}
td:nth-child(4) .comparisonCellNoPadding-4 {
  background-color: rgba(244, 180, 0, 0.4);
}
td:nth-child(4) .comparisonCellNoPadding-5 {
  background-color: rgba(244, 180, 0, 0.5);
}
td:nth-child(4) .comparisonCellNoPadding-6 {
  background-color: rgba(244, 180, 0, 0.6);
}
td:nth-child(4) .comparisonCellNoPadding-7 {
  background-color: rgba(244, 180, 0, 0.7);
}
td:nth-child(4) .comparisonCellNoPadding-8 {
  background-color: rgba(244, 180, 0, 0.8);
}
td:nth-child(4) .comparisonCellNoPadding-9 {
  background-color: rgba(244, 180, 0, 0.9);
}
td:nth-child(4) .comparisonCellNoPadding-10 {
  background-color: rgba(244, 180, 0, 1);
  color: white;
}

/**
* 5th column - Green (Sustainability)
*/
td:nth-child(5) .comparisonCellNoPadding-1 {
  background-color: rgba(15, 157, 88, 0.1);
}
td:nth-child(5) .comparisonCellNoPadding-2 {
  background-color: rgba(15, 157, 88, 0.2);
}
td:nth-child(5) .comparisonCellNoPadding-3 {
  background-color: rgba(15, 157, 88, 0.3);
}
td:nth-child(5) .comparisonCellNoPadding-4 {
  background-color: rgba(15, 157, 88, 0.4);
}
td:nth-child(5) .comparisonCellNoPadding-5 {
  background-color: rgba(15, 157, 88, 0.5);
}
td:nth-child(5) .comparisonCellNoPadding-6 {
  background-color: rgba(15, 157, 88, 0.6);
}
td:nth-child(5) .comparisonCellNoPadding-7 {
  background-color: rgba(15, 157, 88, 0.7);
}
td:nth-child(5) .comparisonCellNoPadding-8 {
  background-color: rgba(15, 157, 88, 0.8);
}
td:nth-child(5) .comparisonCellNoPadding-9 {
  background-color: rgba(15, 157, 88, 0.9);
}
td:nth-child(5) .comparisonCellNoPadding-10 {
  background-color: rgba(15, 157, 88, 1);
  color: white;
}

/**
* 6th column - Purple (Institutions & Governance)
*/
td:nth-child(6) .comparisonCellNoPadding-1 {
  background-color: rgba(156, 39, 176, 0.1);
}
td:nth-child(6) .comparisonCellNoPadding-2 {
  background-color: rgba(156, 39, 176, 0.2);
}
td:nth-child(6) .comparisonCellNoPadding-3 {
  background-color: rgba(156, 39, 176, 0.3);
}
td:nth-child(6) .comparisonCellNoPadding-4 {
  background-color: rgba(156, 39, 176, 0.4);
}
td:nth-child(6) .comparisonCellNoPadding-5 {
  background-color: rgba(156, 39, 176, 0.5);
}
td:nth-child(6) .comparisonCellNoPadding-6 {
  background-color: rgba(156, 39, 176, 0.6);
}
td:nth-child(6) .comparisonCellNoPadding-7 {
  background-color: rgba(156, 39, 176, 0.7);
}
td:nth-child(6) .comparisonCellNoPadding-8 {
  background-color: rgba(156, 39, 176, 0.8);
}
td:nth-child(6) .comparisonCellNoPadding-9 {
  background-color: rgba(156, 39, 176, 0.9);
}
td:nth-child(6) .comparisonCellNoPadding-10 {
  background-color: rgba(156, 39, 176, 1);
  color: white;
}

/**
* 7th column - Teal (Transport & Infrastructure)
*/
td:nth-child(7) .comparisonCellNoPadding-1 {
  background-color: rgba(0, 150, 136, 0.1);
}
td:nth-child(7) .comparisonCellNoPadding-2 {
  background-color: rgba(0, 150, 136, 0.2);
}
td:nth-child(7) .comparisonCellNoPadding-3 {
  background-color: rgba(0, 150, 136, 0.3);
}
td:nth-child(7) .comparisonCellNoPadding-4 {
  background-color: rgba(0, 150, 136, 0.4);
}
td:nth-child(7) .comparisonCellNoPadding-5 {
  background-color: rgba(0, 150, 136, 0.5);
}
td:nth-child(7) .comparisonCellNoPadding-6 {
  background-color: rgba(0, 150, 136, 0.6);
}
td:nth-child(7) .comparisonCellNoPadding-7 {
  background-color: rgba(0, 150, 136, 0.7);
}
td:nth-child(7) .comparisonCellNoPadding-8 {
  background-color: rgba(0, 150, 136, 0.8);
}
td:nth-child(7) .comparisonCellNoPadding-9 {
  background-color: rgba(0, 150, 136, 0.9);
}
td:nth-child(7) .comparisonCellNoPadding-10 {
  background-color: rgba(0, 150, 136, 1);
  color: white;
}

/**
* 8th column - Orange (Innovation)
*/
td:nth-child(8) .comparisonCellNoPadding-1 {
  background-color: rgba(255, 152, 0, 0.1);
}
td:nth-child(8) .comparisonCellNoPadding-2 {
  background-color: rgba(255, 152, 0, 0.2);
}
td:nth-child(8) .comparisonCellNoPadding-3 {
  background-color: rgba(255, 152, 0, 0.3);
}
td:nth-child(8) .comparisonCellNoPadding-4 {
  background-color: rgba(255, 152, 0, 0.4);
}
td:nth-child(8) .comparisonCellNoPadding-5 {
  background-color: rgba(255, 152, 0, 0.5);
}
td:nth-child(8) .comparisonCellNoPadding-6 {
  background-color: rgba(255, 152, 0, 0.6);
}
td:nth-child(8) .comparisonCellNoPadding-7 {
  background-color: rgba(255, 152, 0, 0.7);
}
td:nth-child(8) .comparisonCellNoPadding-8 {
  background-color: rgba(255, 152, 0, 0.8);
}
td:nth-child(8) .comparisonCellNoPadding-9 {
  background-color: rgba(255, 152, 0, 0.9);
}
td:nth-child(8) .comparisonCellNoPadding-10 {
  background-color: rgba(255, 152, 0, 1);
  color: white;
}

/**
* 9th column - Pink (Vibrancy)
*/
td:nth-child(9) .comparisonCellNoPadding-1 {
  background-color: rgba(233, 30, 99, 0.1);
}
td:nth-child(9) .comparisonCellNoPadding-2 {
  background-color: rgba(233, 30, 99, 0.2);
}
td:nth-child(9) .comparisonCellNoPadding-3 {
  background-color: rgba(233, 30, 99, 0.3);
}
td:nth-child(9) .comparisonCellNoPadding-4 {
  background-color: rgba(233, 30, 99, 0.4);
}
td:nth-child(9) .comparisonCellNoPadding-5 {
  background-color: rgba(233, 30, 99, 0.5);
}
td:nth-child(9) .comparisonCellNoPadding-6 {
  background-color: rgba(233, 30, 99, 0.6);
}
td:nth-child(9) .comparisonCellNoPadding-7 {
  background-color: rgba(233, 30, 99, 0.7);
}
td:nth-child(9) .comparisonCellNoPadding-8 {
  background-color: rgba(233, 30, 99, 0.8);
}
td:nth-child(9) .comparisonCellNoPadding-9 {
  background-color: rgba(233, 30, 99, 0.9);
}
td:nth-child(9) .comparisonCellNoPadding-10 {
  background-color: rgba(233, 30, 99, 1);
  color: white;
}

/**
* 10th column - Deep Blue (e-Intelligence)
*/
td:nth-child(10) .comparisonCellNoPadding-1 {
  background-color: rgba(63, 81, 181, 0.1);
}
td:nth-child(10) .comparisonCellNoPadding-2 {
  background-color: rgba(63, 81, 181, 0.2);
}
td:nth-child(10) .comparisonCellNoPadding-3 {
  background-color: rgba(63, 81, 181, 0.3);
}
td:nth-child(10) .comparisonCellNoPadding-4 {
  background-color: rgba(63, 81, 181, 0.4);
}
td:nth-child(10) .comparisonCellNoPadding-5 {
  background-color: rgba(63, 81, 181, 0.5);
}
td:nth-child(10) .comparisonCellNoPadding-6 {
  background-color: rgba(63, 81, 181, 0.6);
}
td:nth-child(10) .comparisonCellNoPadding-7 {
  background-color: rgba(63, 81, 181, 0.7);
}
td:nth-child(10) .comparisonCellNoPadding-8 {
  background-color: rgba(63, 81, 181, 0.8);
}
td:nth-child(10) .comparisonCellNoPadding-9 {
  background-color: rgba(63, 81, 181, 0.9);
}
td:nth-child(10) .comparisonCellNoPadding-10 {
  background-color: rgba(63, 81, 181, 1);
  color: white;
}
</style>
